export default __webpack_public_path__ + "static/media/Techforce-Signup-Bg.3317d784.png";